import { render, staticRenderFns } from "./elePage.vue?vue&type=template&id=464bee4a&scoped=true&"
import script from "./elePage.vue?vue&type=script&lang=js&"
export * from "./elePage.vue?vue&type=script&lang=js&"
import style0 from "./elePage.vue?vue&type=style&index=0&id=464bee4a&scoped=true&lang=css&"
import style1 from "./elePage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464bee4a",
  null
  
)

export default component.exports